import React from 'react';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Solutions from './Solutions';
import Compliance from './Compliance';
import Contact from './Contact';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Solutions />
        <Compliance />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
